const config = {
  env: "local",
  // apiUrl: "http://localhost:8500/admin/",
   apiUrl: "https://api.nkshospital.com/admin/",
  // apiUrl: "https://x7t5zzk2-8500.inc1.devtunnels.ms/admin/",
};

export default config;
